<template>
  <div>
    <div class="WRAPPER">
      <div
          v-for="n in max"
          :key="n">
        <div
            :style="{ fontSize: starSize }"
            :class="darker ? 'c-gray70' : 'c-gray30'"
            :selenium="`rating-star-${n}`"
            class="STAR"
            @mouseover="handleMouseOver(n)"
            @mouseout="handleMouseOut"
            @click="handleClick(n)">
          <vk-icon name="star"/>
        </div>
        <div class="FILLED">
          <div
              :style="{ width: filledWidth(n), fontSize: starSize }"
              :class="hoverValue ? 'c-green' : 'c-depot'"
              class="STAR">
            <vk-icon name="star"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'responsive-rating-stars',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 5,
    },
    darker: {
      type: Boolean,
      default: false,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    starSize: {
      type: String,
      default: '16px',
    },
  },
  data () {
    return {
      hoverValue: null,
    };
  },
  methods: {
    handleMouseOver (n) {
      this.hoverValue = n;
      this.$emit('mouse-over', n);
    },
    handleMouseOut () {
      this.hoverValue = null;
      this.$emit('mouse-out');
    },
    handleClick (n) {
      this.$emit('input', n);
      this.hoverValue = null;
    },
    filledWidth (index) {
      if ((this.value - index) >= 0) {
        return '100%';
      }
      return Math.abs(this.value - index) < 1 ? `${100 * ((Math.ceil(this.value * 2) / 2) - Math.floor(this.value))}%` : '0';
    },
  },
};
</script>
<style lang="scss" scoped>
    .WRAPPER {
        display: flex;
        position: relative;
        &>div {
            margin-right: auto;
        }
    }
    .STAR {
        transition: color 100ms ease;
        & + & {
            padding-left: 0.1em;
        }
    }
    .FILLED {
        position: absolute;
        top: 0;
        pointer-events: none;
        &>div {
            overflow: hidden;
        }
    }
</style>
